/** @format */

import React from 'react';
import { FACTS_FIELD_KEYS } from '../utilities';
import './styles.scss';
import { Unit, checkIfValueIsValid } from '../common';

export const getElectricityData = (props) => {
  const { dataSet, objectText } = props;

  const factKey = FACTS_FIELD_KEYS.ELECTRICITY;

  const electricityData = dataSet[factKey];

  const ElectricityFactsRow = ({ facts }) => {
    const kwhFields = ['powerConsumptionKWH'];

    const factFieldName = facts?.factFieldName;
    if (checkIfValueIsValid(facts?.value)) {
      return (
        <div className='object-listing-accordian-list object-listing-accordian-list-no-border'>
          <div className='object-listing-accordian-list-left'>
            {objectText?.[`${factKey}Obj`]?.[factFieldName]?.label ||
              objectText?.[factKey]?.[factFieldName]?.label ||
              facts?.factFieldName}
          </div>
          <div className='object-listing-accordian-list-right'>
            {facts?.value} <Unit kwhFields={kwhFields} facts={facts} />
          </div>
        </div>
      );
    }

    return <></>;
  };

  const ElectricitySection = () => {
    return (
      <div className='electricity-data-body'>
        <ElectricityFactsRow
          key='companie'
          facts={{
            factFieldName: 'companie',
            value: electricityData?.companie
          }}
        />
        <ElectricityFactsRow
          key='distributor'
          facts={{
            factFieldName: 'distributor',
            value: electricityData?.distributor
          }}
        />
        <ElectricityFactsRow
          key='powerConsumptionKWH'
          facts={{
            factFieldName: 'powerConsumptionKWH',
            value: electricityData?.powerConsumptionKWH
          }}
        />
      </div>
    );
  };

  return {
    component: <ElectricitySection />,
    factsCount: 0
  };
};
